<template>
  <div class="h-dialogContainer">
    <form id="gnbPmDataSearchForm">
      <div class="row">
        <div class="col-sm-6">
          <div class="h-col-inputBox-left">
            <div class="h-inputLit">{{$t('Pm.timeRange')}}</div>
            <ejs-radiobutton :label='$t("Pm.today")' name="timeRange" :checked="true" value="0" :change="changeOfGnbTimeRange"></ejs-radiobutton>
            <ejs-radiobutton :label='$t("Pm.yesterday")' name="timeRange" value="1" :change="changeOfGnbTimeRange"></ejs-radiobutton>
            <ejs-radiobutton :label='$t("Pm.currentWeek")' name="timeRange" value="2" :change="changeOfGnbTimeRange"></ejs-radiobutton>
            <ejs-radiobutton :label='$t("Pm.lastWeek")' name="timeRange" value="3" :change="changeOfGnbTimeRange"></ejs-radiobutton>
            <ejs-radiobutton :label='$t("Pm.specified")' name="timeRange" value="4" :change="changeOfGnbTimeRange"></ejs-radiobutton>
          </div>
          <div class="h-col-inputBox-left">
            <div class="h-inputLit">{{$t('Pm.start_time')}}</div>
            <ejs-datetimepicker :format='dateFormat' :change='validateOfGnbPmSearchDialog' :locale='locale' name="startTime" :enabled='startTimeEnabled' v-model='startTime'></ejs-datetimepicker>
          </div>
          <div class="h-col-inputBox-left">
            <div class="h-inputLit">{{$t('Pm.end_time')}}</div>
            <ejs-datetimepicker :format='dateFormat' :change='validateOfGnbPmSearchDialog' :locale='locale' name="endTime" :enabled='endTimeEnabled' v-model='endTime'></ejs-datetimepicker>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>

  import {FormValidator} from "@syncfusion/ej2-vue-inputs";
  import DateUtil from "../../util/DateUtil";

  export default {
    name: 'GnbPmDataSearchDialog',
    components: {
    },
    data() {
      return {
        locale: localStorage.getItem('locale'),
        startTimeEnabled: false,
        endTimeEnabled: false,
        startTime: new Date(`${DateUtil.getTodayYearMonthDay()} 00:00:00`),
        endTime: new Date(`${DateUtil.getTodayYearMonthDay()} 23:59:59`),
        dateFormat: 'yyyy-MM-dd HH:mm:ss',
        fieldsOfGnbPmDataSearchTree: {
          dataSource: [],
          id: 'id',
          parentID: 'parentId',
          text: 'name',
          hasChildren: 'hasChildren',
          expanded: 'expanded'
        },
        expandedNodes: ['root'],
        checkNodeIdList: [],
        checkNodeList: [],
        formObjOfGnbPmSearchDialog: '',
        optionsOfGnbPmSearchDialogValidation: {
          customPlacement(inputElement, errorElement) {
            errorElement.style.position = 'fixed';
            inputElement.parentElement.parentElement.appendChild(errorElement);
          },
          rules: {
            startTime: {
              required: [true, this.$t('Pm.begTimeNull')],
              regex: [/^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/, this.$t('Pm.begTimeFormatError')]
            },
            endTime: {
              required: [true, this.$t('Pm.begTimeNull')],
              regex: [/^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/, this.$t('Pm.endTimeFormatError')]
            }
          }
        },
      }
    },
    methods: {

      gnbPmDataSearchTreeNodeChecked(args){
        const checkStatus = args.action;
        if(checkStatus == "check"){
          for(let checkedNode of args.data){
            if(checkedNode.hasChildren == false){
              this.checkNodeIdList.push(checkedNode.id);
              this.checkNodeList.push(checkedNode);
            }
          }
        }else if(checkStatus == 'uncheck'){
          for(let checkedNode of args.data){
            this.checkNodeIdList = this.checkNodeIdList.filter(function(id){
              return id != checkedNode.id;
            });
            this.checkNodeList = this.checkNodeList.filter(function(node){
              return node.id != checkedNode.id;
            });
          }
        }
      },


      getGnbPmDataSearchTree(paramTypeCode){
        this.$axios.get(`/lte/ems/pm/gnb/query/getCounterTree.html?paramTypeCode=${paramTypeCode}`).then((response) => {
          this.fieldsOfGnbPmDataSearchTree = {
            dataSource: response.data.resultVal,
            id: 'id',
            parentID: 'parentId',
            text: 'name',
            hasChildren: 'hasChildren',
            expanded: 'expanded'
          };
        });
      },

      changeOfGnbTimeRange(args) {
        switch (args.value) {
          case '0':
            this.startTime = new Date(`${DateUtil.getTodayYearMonthDay()} 00:00:00`);
            this.endTime = new Date(`${DateUtil.getTodayYearMonthDay()} 23:59:59`);
            this.startTimeEnabled = false;
            this.endTimeEnabled = false;
            break;
          case '1':
            this.startTime = new Date(`${DateUtil.getYesterdayYearMonthDay()} 00:00:00`);
            this.endTime = new Date(`${DateUtil.getYesterdayYearMonthDay()} 23:59:59`);
            this.startTimeEnabled = false;
            this.endTimeEnabled = false;
            break;
          case '2':
            this.startTime = new Date(`${DateUtil.getCurrentWeekBeginYearMonthDay()} 00:00:00`);
            this.endTime = new Date(`${DateUtil.getCurrentWeekEndYearMonthDay()} 23:59:59`);
            this.startTimeEnabled = false;
            this.endTimeEnabled = false;
            break;
          case '3':
            this.startTime = new Date(`${DateUtil.getLastWeekBeginYearMonthDay()} 00:00:00`);
            this.endTime = new Date(`${DateUtil.getLastWeekEndYearMonthDay()} 23:59:59`);
            this.startTimeEnabled = false;
            this.endTimeEnabled = false;
            break;
          case '4':
            this.startTime = '';
            this.endTime = '';
            this.startTimeEnabled = true;
            this.endTimeEnabled = true;
            break;
          default:
            break;
        }
      },
      bindValidateOfGnbPmSearchDialog() {
        this.formObjOfGnbPmSearchDialog = new FormValidator('#gnbPmDataSearchForm', this.optionsOfGnbPmSearchDialogValidation);
      },

      validateOfGnbPmSearchDialog() {
        const formStatus = this.formObjOfGnbPmSearchDialog.validate();
        if (!formStatus) {

        }
        return true;
      },
    },
    mounted() {
      this.bindValidateOfGnbPmSearchDialog();
    }
  }
</script>

<style scoped>
  .h-dialogContainer .h-col-inputBox-left {
    margin-bottom: 18px;
    padding-left: 35px;
    padding-right: 10px;
  }

  .h-dialogContainer .h-col-inputBox-middle {
    margin-top: 25px;
    margin-bottom: 5px;
  }

  .h-dialogContainer .h-col-inputBox-right {
    margin-bottom: 18px;
    padding-left: 10px;
    padding-right: 35px;
  }
  .h-dialogContainer{
    height: calc(100vh - 440px);
  }
</style>
